/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpRespDealerDetailsFeedback_reviews$ref = any;
type PdpRespDealerDetailsFeedback_seller$ref = any;
type PdpSharedCallDealerCta_item$ref = any;
type PdpSharedDealerDetailsForm_item$ref = any;
type PdpSharedDealerDetailsStats_reviews$ref = any;
type PdpSharedDealerDetailsStats_seller$ref = any;
type PdpSharedSellerTabsVariant_item$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespDealerDetails_item$ref: FragmentReference;
export type PdpRespDealerDetails_item = {|
  +dealerDetailsDisplayInfo: ?{|
    +ctas: ?{|
      +showMakeOffer: ?boolean
    |}
  |},
  +seller: ?{|
    +serviceId: ?string,
    +trackedPhone: ?{|
      +phoneNumber: ?string
    |},
    +orderFeedbackPdp: ?{|
      +$fragmentRefs: PdpSharedDealerDetailsStats_reviews$ref & PdpRespDealerDetailsFeedback_reviews$ref
    |},
    +$fragmentRefs: PdpRespDealerDetailsFeedback_seller$ref & PdpSharedDealerDetailsStats_seller$ref,
  |},
  +$fragmentRefs: PdpSharedCallDealerCta_item$ref & PdpSharedDealerDetailsForm_item$ref & PdpSharedSellerTabsVariant_item$ref,
  +$refType: PdpRespDealerDetails_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsForm_item",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_item",
      "args": null
    },
    {
      "kind": "LinkedField",
      "alias": "dealerDetailsDisplayInfo",
      "name": "displayInfo",
      "storageKey": null,
      "args": null,
      "concreteType": "ItemDisplayInfo",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "ctas",
          "storageKey": null,
          "args": null,
          "concreteType": "CTADisplay",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "showMakeOffer",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "seller",
      "storageKey": null,
      "args": null,
      "concreteType": "Seller",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "serviceId",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "trackedPhone",
          "storageKey": null,
          "args": null,
          "concreteType": "Phone",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "phoneNumber",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "orderFeedbackPdp",
          "storageKey": null,
          "args": null,
          "concreteType": "SellerOrderFeedbackPdpQueryConnection",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedDealerDetailsStats_reviews",
              "args": null
            },
            {
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetailsFeedback_reviews",
              "args": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpRespDealerDetailsFeedback_seller",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "PdpSharedDealerDetailsStats_seller",
          "args": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7485816e60bd76aea5d08e3a87c18557';
module.exports = node;
